import ShareMsgBase from './A_G.ShareMsgBase';

class MsgGate extends ShareMsgBase {
  /**
   * The message that is sent when you got the key from a friend from answering your request for help
   * @param {function} onAllImagesReadyCallback
   */
  constructor(onAllImagesReadyCallback = null) {
    super(1, onAllImagesReadyCallback);
    this.bg = this._addExtImage(0, 0, 'img/Msg_Gate_Key.png', 0);
  }
}

G.MsgGate = MsgGate;
